<template>
  <el-dialog
    title="附件文件"
    :visible.sync="localVisible"
    :close-on-click-modal="false"
    @close="closeDialog"
    class="dialog-main"
  >
    <div
      class="upload-container"
    >
      <el-upload
        v-if="isUpload"
        class="upload-demo"
        action="/supplierapi/upload"
        :show-file-list="false"
         accept=".jpg, .png, .jpeg, .pdf, .gif, .xls, .csv"
        :before-upload="beforeUpload"
        :on-success="uploadSuccess"
        :on-exceed="handleExceed"
      >
        <el-button class="upload-button" size="small" type="primary">点击上传</el-button>
        <div slot="tip" class="el-upload__tip">只能上传jpg/png/jpeg/pdf/gif/xls/csv文件，且不超过10MB</div>
      </el-upload>
      <div class="preview-container">
        <template
          v-for="(item, index) in fileList"
        >
          <transition :key="index" name="fade">
            <div
              class="preview-item"
            >
              <el-image
                class="file-image"
                :src="fileIcon(item.url)"
                style="width: 50px; height: 50px"
              />
              <div class="file-name" @click="viewFile(item)"
                style="width: calc(100% - 80px);margin-left: 20px"
              >{{ item.name }}</div>
              <el-button
                type="text"
                class="file-close-icon"
                @click="viewFile(item)"
              ><i class="el-icon-view"/></el-button>
              <el-button
                v-if="isUpload"
                type="text"
                class="file-close-icon"
                @click="removeFile(item)"
              >X</el-button>
            </div>
          </transition>
        </template>
      </div>
    </div>
    <div slot="footer" class="upload-footer">
      <el-button @click="closeDialog">{{isUpload ? '取 消' : '关 闭'}}</el-button>
      <el-button v-if="isUpload" type="primary" @click="handleConfirm">确 定</el-button>
    </div>
    <view-file-dialog
      ref="viewFileDialog"
    />
  </el-dialog>
</template>

<script>
import ViewFileDialog from "./ViewFileDialog.vue";

export default {
  name: 'quotedprice-file-upload-dialog',
  components: {ViewFileDialog},
  data(){
    return {
      fileList: [],
      localVisible: false,
    }
  },
  props: {
    visible: {
      type: Boolean,
      default: () => false
    },
    isUpload: {
      type: Boolean,
      default: () => true
    },
    fileListData: {
      type: Array,
      default: () => []
    }
  },
  watch: {
    visible: {
      immediate: true,
      handler(newVal) {
        this.localVisible = newVal;
        this.fileList = JSON.parse(JSON.stringify(this.fileListData)); // 深拷贝
      }
    }
  },
  methods: {
    // 文件大小处理
    beforeUpload(file) {
      if (this.fileList.length >= 9) {
        this.$message.warning('最多上传9个文件')
        return false
      }
      if(file.size > 1024 * 1024) {
        this.$message.warning("文件大小不能超过10M")
        return false
      }
      return true
    },
    // 上传成功处理
    uploadSuccess(response, file, fileList) {
      const remoteUrl = (response.data || {}).full_path;
      const remoteName = (response.data || {}).file_name;
      if(!remoteUrl) return this.$message.error(response.msg)

      this.fileList.push({
        name: remoteName,
        url: remoteUrl,
        path: remoteUrl
      })
      this.$message.success("上传成功")
    },

    // 移除文件处理
    removeFile(item) {
      this.fileList = this.fileList.filter(file => file.url !== item.url);
      this.$message.success("移除成功")
    },

    // 确认后返回数组
    handleConfirm() {
      this.$emit('fileChange', this.fileList);
      this.closeDialog();
    },
    // 关闭弹窗
    closeDialog(){
      this.localVisible = false;
      // 清空数组
      this.fileList = [];
      this.$emit('close');
    },
    // 超出数量提示
    handleExceed(files, fileList) {
      // 超出数量限制时的处理
      this.$message.warning(`最多上传 9 个文件。`);
    },
    // 查看文件
    viewFile(item) {
      const url = item.url || '';
      const extension = url.split('.').pop().toLowerCase();
      const isFile = ['pdf', 'xls', 'csv'].includes(extension);
      if (isFile) {
        window.open(url, '_blank');
      } else {
        this.$refs.viewFileDialog.showDialog(item);
      }
    },

    // listIcon
    fileIcon(url) {
      const extension = url.split('.').pop().toLowerCase();
      const isFile = ['pdf', 'xls', 'csv'].includes(extension);
      if (isFile) {
        return require(`@/assets/file/${extension}.png`);
      } else {
        return url;
      }
    },
  }
}
</script>

<style scoped lang="less">
.dialog-main{
  text-align: center;
  overflow-x: hidden;
  overflow-y: scroll;
  :deep(.el-dialog__body){
    border: 1px solid red;
  }
  .upload-button{
    border-radius: 20px;
    padding: 15px 50px;
  }
}

::v-deep .el-dialog__title{
  color: #2B3347 ;
  font-size: 16px;
}
::v-deep .el-upload__input{
  display: none;
}
::v-deep .el-dialog__body{
  min-height: 320px;
  padding-top: 0;
  .el-upload__tip {
    text-align: center;
    color: #A9B6C4;
    font-size: 12px;
  }
  .preview-container{
    max-height: 40vh;
    overflow: scroll;
    input {
      display: none;
    }
    .preview-item {
      display: flex;
      justify-content: space-between;
      align-items: center;
      background: #F4F5F7;
      border-radius: 4px ;
      padding: 10px;
      .file-name{
        color: #409eff;
        font-size: 14px;
        text-align: left;
        cursor: pointer;
      }
    }
    .preview-item:not(:first-child){
      margin-top: 10px;
    }
  }
}
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
